import React from 'react';
import { AlertIcon, InfoIcon, TickIcon, AdviceIcon, PinnedNoteIcon } from '@domain-group/fe-co-icon';
import { tokens } from '@domain-group/fe-brary';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var messageTypes = ['error', 'warning', 'info', 'success', 'standard', 'decorativeOne', 'decorativeTwo'];
export var messageConfig = {
  error: {
    primary: tokens.colors.critical.base.default,
    background: tokens.colors.critical.subdued.default,
    hover: tokens.colors.critical.subdued.hover,
    icon: ___EmotionJSX(AlertIcon, null)
  },
  warning: {
    primary: tokens.colors.warning.base.default,
    background: tokens.colors.warning.subdued.default,
    hover: tokens.colors.warning.subdued.hover,
    icon: ___EmotionJSX(InfoIcon, null)
  },
  info: {
    primary: tokens.colors.info.base.default,
    background: tokens.colors.info.subdued.default,
    hover: tokens.colors.info.subdued.hover,
    icon: ___EmotionJSX(AdviceIcon, null)
  },
  success: {
    primary: tokens.colors.interactive.base.default,
    background: tokens.colors.interactive.subdued.default,
    hover: tokens.colors.interactive.subdued.hover,
    icon: ___EmotionJSX(TickIcon, null)
  },
  standard: {
    primary: tokens.colors.secondary.base.default,
    background: tokens.colors.secondary.subdued.default,
    hover: tokens.colors.secondary.subdued.hover,
    icon: ___EmotionJSX(InfoIcon, null)
  },
  decorativeOne: {
    primary: tokens.colors.accentOne.base.default,
    background: tokens.colors.accentOne.subdued.default,
    hover: tokens.colors.accentOne.subdued.hover,
    icon: false
  },
  decorativeTwo: {
    primary: tokens.colors.accentTwo.base.default,
    background: tokens.colors.accentTwo.subdued.default,
    hover: tokens.colors.accentTwo.subdued.hover,
    icon: ___EmotionJSX(PinnedNoteIcon, null)
  }
};
export var getMessageConfig = function getMessageConfig(type) {
  return messageConfig[type] || messageConfig.standard;
};